var map = {
	"./bkg.png": "43e8",
	"./fore.png": "8ca5",
	"./mask.png": "deec",
	"./ruban.png": "3158",
	"./ruban_1.png": "6628",
	"./ruban_2.png": "c436",
	"./ruban_3.png": "55d2",
	"./ruban_4.png": "a748",
	"./ruban_5.png": "1d3f",
	"./save/ruban.png": "5573",
	"./save/ruban_1.png": "cd0c",
	"./screen.png": "09c0",
	"./screen_test.png": "7f8b",
	"./tagline.png": "91be",
	"./tagline/1.png": "2110",
	"./tagline/2.png": "b548",
	"./tagline/3.png": "42e8",
	"./tagline/4.png": "d3ab",
	"./tagline/5.png": "478e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6341";